import { G, S } from '@mobily/ts-belt';

/**
 * utility for common use-case; validating in one step that a value
 * is not nullable, is a string, and is not empty
 */
export const isNonEmptyString = (value: unknown): value is string =>
  G.isString(value) && S.isNotEmpty(value);
